import { Directive, ElementRef, HostListener, Input, OnDestroy, ViewContainerRef } from '@angular/core'
import { Overlay, OverlayConfig, ConnectedPosition, OverlayRef } from '@angular/cdk/overlay'
import { TemplatePortal } from '@angular/cdk/portal'
import { NotificationListComponent } from './notification-list/notification-list.component'
import { merge, Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Directive({
  selector: '[linNotificationTriggerFor]',
  standalone: false,
})
export class NotificationTriggerDirective implements OnDestroy {
  private overlayRef: OverlayRef
  private portal: TemplatePortal
  private destroy$ = new Subject<void>()

  @HostListener('keydown')
  onKeyDown() {
    // onKeyDown handle
  }

  @HostListener('click')
  onClick() {
    this.openList()
  }

  @Input('linNotificationTriggerFor') listComponent: NotificationListComponent

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private hostElement: ElementRef,
  ) {}

  openList() {
    const portalRef = this.createPortal()

    this.overlayRef = this.createOverlay()
    this.overlayRef.attach(portalRef)
    this.attachClosingEvents()
  }

  private attachClosingEvents() {
    merge(this.overlayRef.backdropClick(), this.listComponent.close)
      .pipe(takeUntil(this.destroy$))
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      .subscribe(() => this.overlayRef.detach())
  }

  private createOverlay() {
    const config = this.getOverlayConfig()
    return this.overlay.create(config)
  }

  private getOverlayConfig() {
    return new OverlayConfig({
      positionStrategy: this.getOverlayPositionStrategy(),
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
    })
  }

  private getOverlayPositionStrategy() {
    const belowPosition: ConnectedPosition = {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    }

    return (
      this.overlay
        .position()
        .flexibleConnectedTo(this.hostElement)
        // .withLockedPosition()
        .withPositions([belowPosition])
    )
  }

  private createPortal() {
    this.portal = new TemplatePortal(this.listComponent.templateRef, this.viewContainerRef)
    return this.portal
  }

  ngOnDestroy() {
    this.overlayRef?.detach()

    if (this.portal?.isAttached) {
      this.portal.detach()
    }

    this.destroy$.next()
    this.destroy$.complete()
  }
}
